<script setup lang="ts">
import { ICON_PATHS, type PdsIconName } from './icons';

withDefaults(
  defineProps<{
    name: PdsIconName;
    size?: number;
    stroke?: number;
  }>(),
  { size: 24, stroke: 1.5 },
);
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path :d="ICON_PATHS[name]" />
  </svg>
</template>
